import {createStore, combineReducers, applyMiddleware, compose} from "redux";
import thunkMiddleware from 'redux-thunk';

import appReducer from "./reducers/appReducer";
import adminReducer from "./reducers/adminReducer";
import schAttenReducer from "./reducers/scheduleAttendantReducer";


let redurcers = combineReducers({appReducer,adminReducer,schAttenReducer});

//let store = createStore(redurcers, applyMiddleware(thunkMiddleware));

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(redurcers, composeEnhancers(applyMiddleware(thunkMiddleware)));



export default store;